import React, { useState, useEffect } from 'react';
import { authProvider } from '../../services/Security';
import { getBacchusURL, remainingTime } from '../shared/Functions';

export const ServiceAddresses = ({district}) => {
    const [resetToken, setResetToken] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const url = getBacchusURL()

    useEffect(() => {
        if(!district) return;
        loadIframe()
        setResetToken(false)
    }, [resetToken, district])// eslint-disable-line react-hooks/exhaustive-deps

    const loadIframe = () => {
        setCount(count+1)
        authProvider.getNexusTokenFull().then(token => {
            setTimeout(() => setResetToken(true), remainingTime(token.tokenExpires))
            const frame = document.getElementById('service-addresses') as HTMLIFrameElement;
            frame?.contentWindow?.postMessage(JSON.stringify({
                token: token,
                districtId: district?.id
            }), url);
        })
    }

    return (
        <React.Fragment>
            <iframe id="service-addresses"
                title="service-addresses"
                src={`${url}/#/app/service-addresses`}
                width="1600px"
                height="1100px"
                onLoad={() => count > 1 ? null : loadIframe()}
                style={{border: "none", display:"block", marginLeft:"25px"}} />
        </React.Fragment>
    );
}